import { todayIso } from "../utils/DateUtils";

export const COLOR_ITERATION = "#00e6e6";
export const COLOR_CURRENT_ITERATION = "#00b0f0";
export const COLOR_QUARTALS = "#0070c0";
export const COLOR_DONE_QA = "#d0f0c0";
export const COLOR_DONE_NA = "#63278f";
export const COLOR_DIM = "#CFCFC4"
export const COLOR_DONE = "#336600";
export const COLOR_DUPLICATE = "#c0f0c8";
export const COLOR_REMOVED = "#800028";
export const COLOR_IMPEDIMENT = "#404040";
export const COLOR_NA = "#954eca";
export const COLOR_READY4CODING = "#00b050";
export const COLOR_SPECING = "#cc0000";
export const COLOR_PLANNING = "#ffcc00";
export const COLOR_OTHER = "#D3D3D3";
export const COLOR_UNKNOWN = "#F81894";
// Start time and end time defines as hour of day
export const START_TIME = 16;
export const END_TIME = 4;




// Views
export const VIEW_ALL_PLANNED = "1";
export const VIEW_LATE = "2";
export const VIEW_ACTIVE = "3";
export const VIEW_ACTIVE_AND_CURRENT = "4";
export const VIEW_CURRENT_ITERATION = "5";
export const VIEW_NEXT_ITERATION = "6";
export const VIEW_FUTURE = "7";
export const VIEW_DEMO = "8";
export const VIEW_MISSING_DATES = "9";
export const VIEW_QA = "10";
export const VIEW_DONE = "11";
export const VIEW_DEMO_CANDIDATE = "12";
export const VIEW_DEMO_PLANNED = "13";
export const VIEW_DEMO_NOT_SET = "14";
export const VIEW_ACTIVE_LAST_AND_NEWER = "15";


//PLANNING_STATUS
export const PLANNING_STATUS_NA = "9. N/A";

export const VIEW_SELECT_OPTION = [
  { value: VIEW_ALL_PLANNED, label: "All planned" },
  { value: VIEW_LATE, label: "Late" },
  { value: VIEW_ACTIVE, label: "Active" },
  { value: VIEW_ACTIVE_AND_CURRENT, label: "Active & Current" },
  { value: VIEW_ACTIVE_LAST_AND_NEWER, label: "Active, Last & newer" },
  //{ value: VIEW_QA, label: "QA" },
  { value: VIEW_DONE, label: "Done" },
  { value: VIEW_CURRENT_ITERATION, label: "Current iteration" },
  //{ value: VIEW_NEXT_ITERATION, label: "Next iterations" },
  { value: VIEW_FUTURE, label: "Future" },
  { value: VIEW_DEMO_CANDIDATE, label: "Demo Candidate" },
  { value: VIEW_DEMO_PLANNED, label: "Demo Planned" },
  { value: VIEW_DEMO_NOT_SET, label: "Demo not set" },
  //{ value: VIEW_DEMO, label: "Demo" },
  //{ value: VIEW_MISSING_DATES, label: "Missing dates" },
];


export const PRIORITY_DRIVERS_ALL = "<All Priority Drivers>";
export const PRIORITY_DRIVERS_NONE = "<No Priority Driver>";
export const PRIORITY_DRIVERS_PRODUCT_ROADMAP = "Product Roadmap";
export const PRIORITY_DRIVERS_TECHNICAL_ROADMAP = "Technical Roadmap";

export const PRIORITY_DRIVERS_ORDER = [
  'Product Roadmap',
  'Technical Roadmap',
  'Running the service',
  'Maintenance',
  'Sales Opportunity'
];




export const RND_PLANNING_PROJECT = "RnD Planning";
export const PLANNING_PROJECTS = [RND_PLANNING_PROJECT, "Product Discovery Planning"]

export const VIEW_NO_TEAMS = "<No Teams>";
export const TEAMS_LIST = [
  { team: "Apps", project: "Apps", ticketType: "Initiative", defaultAssignee: "Preben Gundersen" },
  { team: "Data Science", project: "Team Data Science", ticketType: "Initiative", defaultAssignee: "Harald Svandal Presthus" },
  { team: "Data platform", project: "Data platform", ticketType: "Epic", defaultAssignee: "Rolf Michelsen" },
  { team: "Infrastructure", project: "Team Infrastructure", ticketType: "Initiative", defaultAssignee: "Andre Kleven" },
  { team: "Insight", project: "Insights", ticketType: "Initiative", defaultAssignee: "Rolf Michelsen" },
  { team: "RoomMate", project: "RoomMate", ticketType: "Initiative", defaultAssignee: "Fredrik Stray" },
  { team: "Test", project: "QA - Testing Project", ticketType: "Initiative ", defaultAssignee: "Danay Pérez Ramírez" },
  { team: "Unity", project: "Unity", ticketType: "Initiative", defaultAssignee: "John Harald Øien Toft" },
  { team: "Vista", project: "Front End", ticketType: "Initiative", defaultAssignee: "Meisam Mirkahromi" },
  { team: "Care", project: "Care 5", ticketType: "Initiative", defaultAssignee: "Håkon Veddegjerde" },
  { team: "Safemate", project: "", ticketType: "", defaultAssignee: "Andre Njaa" },
  { team: "Integrations", project: "Integrations", ticketType: "Initiative", defaultAssignee: "John Harald Øien Toft" },
  { team: "MAUI Apps", project: "MAUI Apps", ticketType: "Initiative", defaultAssignee: "John Harald Øien Toft" },

]
export const VIEW_SELECT_TEAMS_OPTION = [
  { value: VIEW_NO_TEAMS, label: "<No Teams>" },
  ...TEAMS_LIST.map((item) => { return { value: item.team, label: item.team } }).sort((a, b) => a.label > b.label ? 1 : -1)
]


// export const VIEW_SELECT_QUARTER_OPTION = [
//   { value: "All", label: "All" },
//   { value: "25Q1", label: "Q1 2025" },
//   { value: "25Q2", label: "Q2 2025" },
//   { value: "25Q3", label: "Q3 2025" },
//   { value: "25Q4", label: "Q4 2025" }
// ];

//*************************************************************************
/* Azure DevOps Constants
 *************************************************************************/
export const AZURE_DEVOPS_BASE_URI = "https://dev.azure.com/sensio/";
export const AZURE_DEVOPS_API_URI = AZURE_DEVOPS_BASE_URI + "_apis/";
export const AZURE_DEVOPS_BASE_TICKET_URI = AZURE_DEVOPS_BASE_URI + "_workitems/edit/";

export const AZURE_Q_FIELDS = "Select [System.Id] , [System.Title], [System.State], [Custom.EndIteration], [Custom.StartIteration], [Custom.PlanningPriority], [System.AssignedTo], [System.Description] From WorkItems "
export const AZURE_Q1 = AZURE_Q_FIELDS + " WHERE [Custom.EndIteration] <> '' AND [State] <> 'Closed' AND [State] <> 'Removed' "
export const AZURE_Q_ORDER_BY = " order by [Custom.PlanningPriority] asc, [Custom.StartIteration] asc, [System.CreatedDate] asc";
export const AZURE_Q_PROJECT = " and [System.TeamProject] = "
export const AZURE_SPECS = ["FuncSpec", "DevPlan", "TestSpec"];


//#region Triage
export const AF_TRIAGE_DATA = "Custom.TriageData";
export const AF_TRIAGE_DATES = "Custom.TriageDates";
export const AF_TRIAGE_DECISION = "Custom.TriageDecision";
export const AF_REPRO_STEPS = "Microsoft.VSTS.TCM.ReproSteps";
export const AF_DESCRIPTION = "System.Description";
export const AF_JUSTIFICATION = "Microsoft.VSTS.CMMI.Justification";
export const AF_JIRA_LINK = 'Custom.JiraLink';
//#endregion Triage


export const ADO_ASSIGNED_ALL = "<All>";
export const ADO_UNASSIGNED = "<Unassigned>"
export const ADO_INITIATIVE_ALL = "<All>";
export const ADO_INITIATIVE_BLANK = "<No Initiative>"

export const ADO_INACTIVE_STATUSES = ["Done", "Closed", "Resolved", "Won't do", "WontDo", "Candidate", "Removed"]
export const ADO_VALID_LINK_TYPES = ["Dependency-Forward", "Dependency-Reverse", "Hierarchy-Forward", "Hierarchy-Reverse", "Related"];

export const ADO_IMPEDIMENT_TYPES = ["Impediment"]
export const ADO_PLANNING_STATUSES = [
  { value: '0. Not Started', label: '0. Not Started' },
  { value: '1. FuncSpec in-progress', label: '1. FuncSpec in-progress' },
  { value: '2. FuncSpec Complete', label: '2. FuncSpec Complete' },
  { value: '3. DevPlan in-progress', label: '3. DevPlan in-progress' },
  { value: '4. Ready-for-coding', label: '4. Ready-for-coding' },
  { value: '9. N/A', label: '9. N/A' },
];


export const TRIAGE_TEXT =
  [
    {
      triage: "Triage Yes",
      standardTexts: [
        { name: "Yes", value: "Triage: Yes, ready for development" },
        { name: "Yes, if small", value: "Triage: Yes, let us fix this if it is small, if not please bring it back for retriage" }
      ]
    },
    {
      triage: "Triage No",
      standardTexts: [
        { name: "Below the bar", value: "Triage: No, Below the bar" },
        { name: "No, not in isolation", value: "Triage: No. We will not take this in isolation, improvements may be included in future versions" }
      ]
    },
    {
      triage: "Cannot reproduce",
      standardTexts: [
        { name: "Cannot reproduce", value: "Triage: No, Cannot reproduce. The problem report has been analyzed but we are unable to reproduce the issue" },
        { name: "No reponse", value: "Triage: No, Cannot reproduce. The problem report has been analyzed, but we are unable to reproduce the issue. Further requests for more information from the bug reporter has been unanswered." }
      ]
    },
    {
      triage: "Not a Bug",
      standardTexts: [
        { name: "Not a bug", value: "Triage: No, Not a bug. The problem report has been analyzed the issue is not a bug, please consult the product documentation for a detailed description of the feature" },
        { name: "Not supported", value: "Triage: No, Not a bug. The problem report has been analyzed the issue is not a bug. The feature is not built to support the reported behavior." }
      ]
    },
    {
      triage: "Need More Info",
      standardTexts: [
        { name: "NeedMoreInfo", value: "Triage: NeedMoreInfo. The problem report has been analyzed and more information is needed to proceed, pleaes provice <insert details>" },
        { name: "Not an isolated reproducible bug", value: "Triage: NeedMoreInfo. The problem report has been analyzed and is is not an isolated reproducible bug. More information is needed to proceed, please consult https://sensio.atlassian.net/wiki/spaces/TDeng/pages/32143900673/How+to+create+good+bug+reports" },
      ]
    },

  ]


export const ADO_OPS_PROJECT = "5eba0ff3-bf3e-47a6-b64d-2a6d776622d3";
export const ADO_OPS_TRIAGE_QUERY = AZURE_Q_FIELDS + " WHERE  [System.TeamProject] = 'Operations'" + AZURE_Q_ORDER_BY;

export const ADO_TRIAGE_PROJECTS = [
  "c65e8f3b-c17c-4ddb-b567-4e249c025223", // APPS
  "fb1d55bd-b1ec-4bd6-b747-8d7a809943d9", //frontend
  "abc8e8c9-07d5-4c74-b59f-3b561211598b", // oyvindh
  "897cbb6e-8a8f-412b-8491-09dd2f1daf06", //RoomMate
  "645350c7-676e-4376-b777-78d3cff86d3b", // Unity
  "56d8f542-cd55-45b2-8f55-b762fd3475ff", // Triage
]

const ADO_TRIAGE_FIELDS = "[System.Id], [System.Title], [System.State], [Custom.EndIteration], [Custom.StartIteration], [Custom.PlanningPriority], [System.AssignedTo], [Microsoft.VSTS.TCM.ReproSteps]"
export const ADO_TRIAGE_QUERY = "Select " + ADO_TRIAGE_FIELDS + " From WorkItems WHERE ([State] = 'Ready4Triage' OR [State] = 'Ready for triage' OR [" + AF_TRIAGE_DATES + "] CONTAINS '" + todayIso() + "')"

export const AZURE_PLANNING_QUERY_OPS = {
  label: "Operations Planning",
  value: "0ec7dc3e-8f50-4f8a-919f-a83c0396c2b7",
  query: AZURE_Q1 + "AND [System.TeamProject] = 'Operations'" + AZURE_Q_ORDER_BY,
}
export const AZURE_PLANNING_QUERY_TEST_FOR_OYVINDH = {
  label: "Test for oyvindh",
  value: "{ea2c77fe-589a-4865-9f9f-6a149a649a3c}",
  query: AZURE_Q1 + "AND [System.TeamProject] = 'Test for oyvindh'" + AZURE_Q_ORDER_BY,
}

/*export const AZURE_TIMELINE_FILTERS = {
  filterList: [
    AZURE_PLANNING_QUERY_OPS,
    AZURE_PLANNING_QUERY_TEST_FOR_OYVINDH
  ],
  getFilterById(filterId) {
    return this.filterList.filter((filt) => {
      return filt.id === filterId;
    })
  },
  getFilterByName(filterName) {
    return this.filterList.filter((filt) => {
      return filt.name === filterName;
    })
}
};
*/
